import React from 'react';
import { CookieNotification } from '../notifications/cookieNotification.jsx';
import { Persistent320x50MobileWebAd } from '../persistent320x50MobileWebAd/persistent320x50MobileWebAd';
import { NotificationFooter } from '../notifications/notificationFooter.jsx';
import styled from 'styled-components';

export const BottomSectionDisplay = () => {
    return (
        <Container>
            <NotificationFooter />
            <Persistent320x50MobileWebAd />
        </Container>
    );
};

const Container = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    width: 100%;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 99;
`;